import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { triangularRuler } from '../../../../../../../../../../shared/assets/emojis';

import { DocumentsBox, FileInputContainer, FileInput, UploadedFile, SelectInputFile, Button, LoadingCircle } from 'hosman-material';

import { getDocuments, getDocumentTypes, fileEdit, addInput, updateInputs, addDocument, deleteDocument, handleDocChanges } from '../../../../../../../../../reducers/SellerApp/documentsSlice';
import { updatePhotoPacks, updateStep } from '../../../../../../../../../reducers/SellerApp/photoMeetingsSlice';

const DiagsUploader = () => {  
  const { groupedDocumentTypes, addedInputs, mandatoryDocs, uploadedOptionalDocs, allDocs, isLoading, lastDocumentUpload } = useSelector((state) => state.sellerDocuments);
  const { user } = useSelector((state) => state.user);
  const { sale } = useSelector((state) => state.sellerSales);
  const [propertyKindGroup, setPropertyKindGroup] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const dispatch = useDispatch()

  useEffect(() => {
    if (!sale.id) return;
    const kindGroup = handlePropertyKindGroup(sale.property.kind)

    setPropertyKindGroup(kindGroup)
    dispatch(getDocuments(sale.id));
    dispatch(getDocumentTypes(kindGroup));
  }, [sale])

  useEffect(() => {
    if (Object.keys(groupedDocumentTypes).length === 0) return;

    dispatch(handleDocChanges(propertyKindGroup))
  }, [groupedDocumentTypes, propertyKindGroup])

  const handlePropertyKindGroup = (propertyKind) => {
    let group = null
    const apartmentGroup = ['apartment', 'duplex', 'triplex', 'loft']
    const houseGroup = ['house', 'mansion']

    if (apartmentGroup.includes(propertyKind)) group = 'apartment'
    if (houseGroup.includes(propertyKind)) group = 'house'

    return group || 'other'
  }

  const handleOptionChange = ({ id }) => {
    dispatch(addInput(id));
  }

  const handleUpload = async (file, dataFile) => {     
    dispatch(fileEdit(dataFile))

    const form = new FormData();
    form.append('file', file);
    form.append('document_type_id', dataFile.id);
    
    try {
      const resultAction = await dispatch(addDocument({ saleId: sale.id, form: form }));
  
      if (addDocument.fulfilled.match(resultAction)) {
        dispatch(updateInputs(dataFile));
      }
    } catch (error) {
      console.error("Erreur lors de l'upload du document :", error);
    }
  }

  const documentCanBeDeleted = (document) => {
    return document.uploader_id === user.id && sale.state === 'awaiting_publication'
  }

  const handleNextStep = async () => {
    setIsSubmitting(true)

    try {
      const resultAction = await dispatch(
        updatePhotoPacks({ saleId: sale.id, params: { lightshop_pack_max: false } })
      );

      if (updatePhotoPacks.fulfilled.match(resultAction)) {
        setIsSubmitting(false)
        dispatch(updateStep('PhotoMeeting'));
      }
    } catch (error) {
      setIsSubmitting(false)
      console.error('Erreur lors de la mise à jour des packs photo :', error);
    }
  }

  return (
    <div className='flex flex-col gap-6'>
      <p className='h2'>Importer vos diagnostics</p>

      {mandatoryDocs.length < 1 ? 
        <div className='mx-auto'><LoadingCircle /></div>
      :
        <DocumentsBox emoji={triangularRuler} title='Diagnostics liés au bien' >
          <div className='flex flex-col gap-8 pb-12'>
            {mandatoryDocs.map((doc, index) => (
              doc.category_slug === 'diagnostic' &&
              <FileInputContainer
                key={`${doc.id}-${index}`}
                name={doc.name}
                uploaded={doc.documents.length > 0}
                mandatory={doc[`mandatory_${sale?.property?.kind}`] === true}>
                {doc.documents.length > 0 ?
                  doc.documents.map((file, index) => (
                    <UploadedFile
                      key={`${file.id}-${index}`}
                      file={file}
                      deleteAction={documentCanBeDeleted(file) && (() => dispatch(deleteDocument(file.id)))}
                    />
                  ))
                :
                  <FileInput
                    key={`${doc.id}-${index}`}
                    name={doc.name}
                    dataFile={doc}
                    handleUpload={handleUpload}
                    isLoading={isLoading && lastDocumentUpload.id == doc.id} />
                }
              </FileInputContainer>
            ))}

            {uploadedOptionalDocs.map((doc, index) => (
              doc.category_slug === 'diagnostic' &&
              <FileInputContainer
                key={`${doc.id}-${index}`}
                name={doc.name}
                uploaded={true}>
                  {doc.documents.map((file, index) => (
                    <UploadedFile
                      key={`${file.id}-${index}`}
                      file={file}
                      deleteAction={documentCanBeDeleted(file) && (() => dispatch(deleteDocument(file.id)))}
                    />
                  ))}
              </FileInputContainer>
            ))}

            {Object.values(addedInputs['diagnostic']).length > 0 && Object.values(addedInputs['diagnostic']).map((input, index) => (
              <FileInputContainer
                key={`${input.id}-${index}`}
                name={input.name}>
                  <FileInput
                    key={`${input.id}-${index}-file`}
                    name={input.name}
                    dataFile={input}
                    handleUpload={handleUpload}
                    isLoading={isLoading && lastDocumentUpload.id == input.id} />
              </FileInputContainer>
            ))}

            {allDocs.length > 1 &&
              <SelectInputFile 
                label="D'autres diagnostics individuels à nous transmettre ?" 
                optionList={allDocs} 
                categorySlug='diagnostic' 
                handleChange={handleOptionChange} 
                autoScroll={false} 
              />
            }
          </div>
        </DocumentsBox>
      }

      <div className='flex flex-col md:flex-row justify-between gap-3'>
        <Button label='Retour' type='tertiary' onClick={() => dispatch(updateStep('Diagnostics'))} />
        <Button label='Continuer' onClick={() => handleNextStep()} disabled={mandatoryDocs.find(doc => doc.category_slug === 'diagnostic')?.documents?.length < 1} isLoading={isSubmitting} />
      </div>
    </div>
  )
}

export default DiagsUploader;
